<template>
    <div class="vip-page">
        <!-- 左侧栏 -->
        <div class="sidebar">
            <div class="avatar-box" v-if="loginStatus === 1">
                <img class="avatar" src="../assets/icon8.png" alt="avatar" />
                <div class="user-id">{{userInfo.userName}}</div>
                <div class="welcome">您好，欢迎登录</div>
            </div>
            <div class="avatar-box" v-else @click="onLoginClick">
                <img class="avatar" src="../assets/icon10.png" alt="avatar" />
                <div class="user-id">点击登录</div>
                <div class="welcome">登录成功，即可购买会员</div>
            </div>
            <div class="vip-features">
                <div class="features-title">会员特权</div>
                <ul>
                    <li>✔ 播放特权</li>
                    <li>✔ 去除强制广告</li>
                </ul>
            </div>
        </div>
        <!-- 中间内容 -->
        <div class="main-content">
            <div class="vip-title">{{fromMethodText}}</div>
            <div class="vip-tabs">
                <div v-for="(tab, index) in tabs" :key="index" :class="{ tab: true, active: activeTabIndex === index }" @click.stop="changeVersion(item,index)">
                    <img :src="require(`../assets/${tab.icon}`)" alt="" /> {{ tab.name }}
                </div>
            </div>
            <div class="card-list">
                <div class="card" v-for="(item,index) in timelist[activeTabIndex]" :key="index" @click.stop="changerDay(item,index)" :class="{ active: changerIndex === index }">
                    <div class="card-tag card-color-six" v-if="item.status === 1">超值优惠</div>
                    <div class="month">{{ item.day }}</div>
                    <div class="price">
                        <div class="unit">￥</div>
                        <div class="fee">{{ item.fee }} </div>
                        <div class="origin">￥{{ item.oldfee }}</div>
                    </div>
                    <div class="desc" v-if="item.discount">{{ item.discount }}</div>
                </div>
            </div>
            <div class="pay-title">付款方式</div>
            <div class="pay-methods">
                <div v-for="(tab, index) in payTypeTabs" :key="index" :class="{ tab: true, active: activePayIndex === index }" @click.stop="changePayType(item,index)">
                    <img :src="require(`../assets/${tab.icon}`)" alt="" /> {{ tab.name }}
                </div>
            </div>
            <button class="pay-now" @click="payUserOrder" v-if="activeTabIndex != -1 && payAgree && !paySending">立即付款</button>
            <button class="pay-now-block" v-else>立即付款</button>
            <div class="agreement agreement-item">
                <el-checkbox v-model="payAgree" style="display:inline-block">
                    <div class="changer_sl">
                        <div style="color:#333;display:inline-block;">我已阅读并同意</div>
                        <a href="javascript:void(0)" class="link" @click="onOpenUrl(2)">《会员协议》</a>
                    </div>
                </el-checkbox>
            </div>
        </div>
        <!-- 右侧二维码 -->
        <div class="qr-section" v-if="allFee != null">
            <div class="qr-price">
                <div class="unit">￥</div>
                <div class="fee">{{ allFee.fee }}</div>
            </div>
            <img class="qr-img" :src="qrImg" alt="二维码" v-if="qrImg"/>
            <div class="qr-tip" v-if="qrImg">请使用{{payTypeTabs[activePayIndex].text}}支付</div>
            <button class="view-pay-now" v-if="qrImg" @click="viewPayResult">查看支付结果</button>
        </div>
    
        <div class="mockBack" v-show="showUserLogin == true"></div>
        <div class="login-form-card" v-show="showUserLogin == true">
            <img @click.stop="onCloseShow" style="position: absolute;right: 15px;width: 20px;top: 10px;cursor: pointer;" src="../assets/icon12.png" alt="">
            <div class="login-title">欢迎登录</div>
            <el-form :model="form" class="login-form">
                <el-form-item>
                    <el-input v-model="form.phone" maxlength="11" placeholder="手机号" class="phone-group">
                        <template slot="prepend">
                            <el-select v-model="form.area" class="area-select-inner" placeholder="+86" style="width: 70px">
                                <el-option label="+86" value="86" />
                            </el-select>
                        </template>
                    </el-input>
                </el-form-item>
                <el-form-item> 
                    <el-input v-model="form.code" placeholder="验证码" class="code-group" maxlength="6">
                        <template slot="append">
                            <el-button class="send-code-btn" type="text" v-if="!isCounting" @click="onSendPhoneCode" :disabled="loginSending || !agree">
                                发送验证码</el-button>
                            <span class="send-code-count" v-if="isCounting">{{countdown}}</span>
                        </template>
                    </el-input>
                </el-form-item>
                
                <el-form-item>
                    <el-button class="login-btn" type="primary" @click="onLogin" :disabled="loginSending || !agree">立即登录</el-button>
                </el-form-item>
                <el-form-item class="agreement-item">
                    <el-checkbox v-model="agree" style="display:inline-block">
                        <div class="changer_sl">
                            <div style="color:#000">我已阅读并同意</div>
                            <a href="javascript:void(0)" class="link" @click="onOpenUrl(0)">《用户协议》</a>
                            <div class="link">和</div>
                            <a href="javascript:void(0)" class="link" @click="onOpenUrl(1)">《隐私条款》</a>
                        </div>
                    </el-checkbox>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
import { mobileCodeLogin, sendMobileCode, getUserInfo, appCoverToWeb } from '@/api/user'
import { getPayInfo, payOrder } from '@/api/pay'
import QRCode from 'qrcode'
export default {
    name: 'IndexHome',
    data() {
        return {
            fromMethodText: "",
            fromType: 0,    //支付方式： 0，开通会员； 1，会员续费； 2，升级全功能
            loginStatus: 0,     //是否已经登陆

            //登录表单
            form: {
                area: '86',
                phone: '',
                code: '',
            },
            agree: false,   //是否同意协议
            loginSending: false,     //是否在发送
            phoneSend: '',      //获取到验证码的手机号码
            isCounting: false,  //倒计时
            countdown: 60,  //倒计时数字

            //用户信息
            userInfo: {
                userName: "xxxxxx"
            },

            //版本情况
            tabs: [
                //{ id: 1, name: 'Windows 系统会员', icon: 'icon3.png' },
                //{ id: 100, name: '全平台会员', icon: 'icon4.png' }
            ],
            //收费方面的情况
            timelist: [
                //[
                //{ id: 1, day: "12个月", fee: "169", oldfee: "360", discount: "加赠3个月", status: 1 },
                //{ id: 2, day: "12个月", fee: "178", oldfee: "360", discount: "低至3.5折", status: 2 },
                //],[
                //{ id: 1, day: "12个月", fee: "169", oldfee: "360", discount: "加赠3个月", status: 1 },
                //{ id: 2, day: "12个月", fee: "178", oldfee: "360", discount: "低至3.5折", status: 2 },
                //]
            ],
            //支付情况
            payTypeTabs: [
                //{ id: 1, name: '微信支付', text: '微信扫码', icon: 'icon5.png' },
                //{ id: 2, name: '支付宝', text: '支付宝扫码', icon: 'icon6.png' }
            ],

            activeTabIndex: -1,  //版本情况
            changerIndex: -1,    //收费方面的情况
            activePayIndex: -1,  //支付情况

            payAgree: false,   //是否同意充值协议
            paySending: false,     //是否在发送
            allFee: null,       //右边显示的支付金额
            showUserLogin: false,   //登陆窗口
            loginForPay: false,     //是否为了支付而登录
            qrImg: ''   //支付二维码内容
        }
    },

    mounted() {
        this.initPage();
    },

    watch: {
        allFee: {
            handler(newVal) {
                if (newVal && newVal.fee) {
                    this.generateQR("")
                }
            },
            immediate: true
        }
    },
    
    methods: {
        //初始化页面
        initPage() {
            this.fromType = 0;
            try {
                const paramType = this.$route.query.type; // 例如获取名为paramName的参数
                console.log(paramType);
                if (!(paramType === undefined)) {
                    this.fromType = paramType;
                }
            } catch (err) {
                //
            }
            if (this.fromType == 0) {
                this.fromMethodText = "开通会员";
            } else if (this.fromType == 1) {
                this.fromMethodText = "会员续费";
            } else if (this.fromType == 2) {
                this.fromMethodText = "会员升级";
            }


            let frommethodVal = 0;
            try {
                const frommethod = this.$route.query.frommethod; // 例如获取名为paramName的参数
                if (!(frommethod === undefined)) {
                    frommethodVal = parseInt(frommethod);
                }
            } catch (err) {
                //
            }

            //判断是WEB的页面，还是APP的页面
            if (frommethodVal == 0) {
                this.loadUserInfo();
                this.loadPayInfo(true, false);
            } else if (frommethodVal == 200) {  //无登录状态
                //this.loadUserInfo();
                this.loadPayInfo(true, false);
            } else {
                //读取浏览器参数
                let tokenVal = "";
                try {
                    const tokenStr = this.$route.query.key; // 例如获取名为paramName的参数
                    if (!(tokenStr === undefined)) {
                        tokenVal = tokenStr;
                    }
                } catch (err) {
                    //
                }
                if (tokenVal == "") {
                    this.$message.error('登录失败，请重新点击应用程序登录')
                    return;
                }
                //用户先登录
                this.loginUserByApp(frommethodVal, tokenVal);
            }
        },
        //用户登录
        async loginUserByApp(fromMethodVal, tokenVal) {
            const params = {
                fromDevice: fromMethodVal,
                data: tokenVal
            }
            try {
                const res = await appCoverToWeb(params);
                //设置cookie
                if (res.success) {
                    //重新载入数据
                    this.$router.replace('/pay?type='+this.fromType);
                    //this.loadUserInfo();
                    //this.loadPayInfo(true, false);
                    this.initPage();
                } else {
                    this.$message.error(res.msg)
                }
            } catch (err) {
                this.$message.error('登录失败，请重新点击应用程序登录')
            }
        },

        //设置icon
        loadParamsIcon() {
            //版本情况
            let i=0;
            for (i=0; i<this.tabs.length; i++) {
                if (this.tabs[i].id == 1) {     //Windows 系统会员
                    this.tabs[i].icon = 'icon3.png';
                } else if (this.tabs[i].id == 100) {      //全平台会员
                    this.tabs[i].icon = 'icon4.png';
                }
            }
            //支付情况
            for (i=0; i<this.payTypeTabs.length; i++) {
                if (this.payTypeTabs[i].id == 1) {  //微信支付
                    this.payTypeTabs[i].icon = 'icon5.png';
                } else if (this.payTypeTabs[i].id == 2) {   //支付宝
                    this.payTypeTabs[i].icon = 'icon6.png';
                }
            }
        },

        //初始化选择
        initSelect() {
            this.activeTabIndex = 0;  //版本情况
            this.changerIndex = 0;    //收费方面的情况
            this.activePayIndex = 0;  //支付情况

            this.allFee = this.timelist[0][0];
        },

        //改变购买版本信息
        changeVersion(item, index) {
            this.activeTabIndex = index;
            //console.log("" + this.changerIndex + " " + this.timelist[this.activeTabIndex].length);
            if (this.changerIndex >= this.timelist[this.activeTabIndex].length) {
                this.changerIndex = 0;
            }
            this.allFee = this.timelist[this.activeTabIndex][this.changerIndex];
        },

        //改变选中的套餐
        changerDay(item, index) {
            this.changerIndex = index;
            this.allFee = item;
        },

        //改变选中的支付方式
        changePayType(item, index) {
            if (this.activePayIndex != index) {
                this.activePayIndex = index;
                //this.allFee = this.timelist[this.activeTabIndex][this.changerIndex];
                this.generateQR("");
            }
        },

        //载入用户信息
        async loadUserInfo() {
            try {
                const res = await getUserInfo();
                //console.log(res)
                if (res.success) {
                    this.loginStatus = 1;
                    this.userInfo = res.data;
                } else {
                    this.$message.error(res.msg)
                }
            } catch (err) {
                this.$message.error('请求失败')
            }
        },

        //载入支付信息
        async loadPayInfo(initFlag, payFlag) {
            try {
                const params = {
                    fromType: this.fromType
                }
                const res = await getPayInfo(params);
                //console.log(res)
                if (res.success) {
                    let oldTabs = JSON.stringify(this.tabs);
                    let oldTimelist = JSON.stringify(this.timelist);
                    let oldPayTypeTabs = JSON.stringify(this.payTypeTabs);

                    this.tabs = res.data["version"];
                    this.timelist = res.data["pay"];
                    this.payTypeTabs = res.data["payType"];

                    // 载入支付图标
                    this.loadParamsIcon();
                    if (initFlag)
                    {
                        this.initSelect();  //初始化选择
                    } else {
                        let newTabs = JSON.stringify(this.tabs);
                        let newTimelist = JSON.stringify(this.timelist);
                        let newPayTypeTabs = JSON.stringify(this.payTypeTabs);

                        //判断是否有支付条件的变化
                        let changeFlag = true;

                        if (oldTabs === newTabs && oldTimelist === newTimelist && oldPayTypeTabs === newPayTypeTabs) {
                            changeFlag = false;
                        }

                        if (changeFlag) {
                            payFlag = false;    //改变了就不支付了
                            this.initSelect();  //初始化选择
                        }

                        if (!changeFlag && payFlag) {   //如果没有改变，而且要支付，就去请求支付
                            this.payUserOrder();    //请求支付
                        }
                    }
                } else {
                    this.$message.error(res.msg)
                }
            } catch (err) {
                this.$message.error('请求失败')
            }
        },

        //支付
        async payUserOrder() {
            if (this.loginStatus !== 1) {
                //未登录，先登录
                this.loginForPay = true;
                this.showUserLogin = true;
                return;
            }
            const params = {
                tabIndexId: this.tabs[this.activeTabIndex].id,
                tabIndex: this.activeTabIndex,    //版本情况
                changerIndexId: this.timelist[this.activeTabIndex][this.changerIndex].id,
                changerIndex: this.changerIndex,    //收费方面的情况
                payIndexId: this.payTypeTabs[this.activePayIndex].id,
                payIndex: this.activePayIndex,     //支付情况
                fromType: this.fromType
            }
            try {
                this.paySending = true;
                const res = await payOrder(params);
                this.paySending = false;
                //console.log(res)
                if (res.success) {
                    this.generateQR(res.data);
                } else {
                    this.$message.error(res.msg)
                }
            } catch (err) {
                this.paySending = false;
                this.$message.error('请求失败')
            }
        },

        //查看支付结果
        viewPayResult() {
            this.$router.push('/user');
        },

        //生成支付二维码
        async generateQR(text) {
            try {
                this.qrImg = await QRCode.toDataURL(text)
            } catch (err) {
                this.qrImg = ''
            }
        },

        //点击登陆，弹出登录弹窗
        onLoginClick() {
            this.showUserLogin = true;
        },

        //关闭登录弹窗
        onCloseShow(){
            this.showUserLogin = false;
            this.loginForPay = false;
        },

        //验证码倒计时
        verification() {
            if (this.isCounting) {
                return;
            }
            this.isCounting = true;
            this.countdown = 60;    //赋值60秒
            const times = setInterval(() => {
                this.countdown--; //递减
                if (this.countdown === 0) {
                    // === 0 变成获取按钮
                    clearInterval(times);
                    this.isCounting = false;
                }
            }, 1000);
        },

        //发送验证码
        async onSendPhoneCode() {
            if (this.form.phone == '' || (!(/^1[345789]\d{9}$/.test(this.form.phone)))) {
                this.$alert("请输入手机号。");
                return;
            }

            this.phoneSend = this.form.phone;
            const params = {
                area: this.form.area,
                phone: this.form.phone
            }
            try {
                this.loginSending = true;
                const res = await sendMobileCode(params);
                this.loginSending = false;
                //console.log(res)
                if (res.success) {
                    // 验证码倒计时
                    this.verification();
                } else {
                    this.$message.error(res.msg)
                }
            } catch (err) {
                this.loginSending = false;
                this.$message.error('请求失败')
            }
        },

        //登录
        async onLogin() {
            if (this.form.phone == '' || (!(/^1[345789]\d{9}$/.test(this.form.phone)))) {
                this.$alert("请输入手机号。");
                return;
            }

            if (this.form.code == '' || (!(/^[0-9]\d{5}$/.test(this.form.code)))) {
                this.$alert("请输入验证码。");
                return;
            }

            if (this.phoneSend == "") {
                this.phoneSend = this.form.phone;
            }
            const params = {
                area: this.form.area,
                phone: this.phoneSend,
                code: this.form.code,
                fromDevice: 0   //固定为0，web
            }
            try {
                this.loginSending = true;
                const res = await mobileCodeLogin(params);
                this.loginSending = false;
                //console.log(res)
                if (res.success) {
                    this.loginStatus = 1;   //登录成功
                    this.showUserLogin = false; //关闭弹窗
                    this.loadUserInfo();    //载入用户信息
                    if (this.loginForPay) { //为了支付而登录
                        this.loadPayInfo(false, true);     //载入支付信息
                    } else {
                        this.$message.success("登录成功")
                        this.loadPayInfo(false, false);     //载入支付信息
                    }
                } else {
                    this.$message.error(res.msg)
                }
            } catch (err) {
                this.loginSending = false;
                this.$message.error('请求失败')
            }
        },

        //打开协议文件
        onOpenUrl(val) {
            if (val == 0) {
                window.open('https://user.ssscreen.cn/note/user.html', '_blank');
            } else if (val == 1) {
                window.open('https://user.ssscreen.cn/note/privacyAgreement.html', '_blank');
            } else if (val == 2) {
                window.open('https://user.ssscreen.cn/note/member.html', '_blank');
            }
        }
    }
}
</script>

<style scoped lang="less">
.vip-page {
    display: flex;
    height: 100vh;
    background: #fdf6f1;
    font-family: 'PingFang SC', 'Microsoft YaHei', Arial, sans-serif;
}

.card-list {
    display: flex;
    gap: 10px;
    margin-bottom: 16px;
    .card {
        background: #fff;
        border-radius: 6px;
        width: 146px;
        text-align: center;
        border: 1px solid #eee;
        position: relative;
        color: #4d2c1d;
        font-size: 14px;
        cursor: pointer;
    }
    .active {
        background: linear-gradient(to bottom, #FFF4E7, #FFE8C6);
        border: 1px solid #d3b794;
    }
    .active .desc {
        background: #FFDFB2;
        color: #815A12;
    }
    .active .price .origin {
        color: rgba(129, 90, 18, 0.6);
    }
    .card-tag {
        position: absolute;
        border-radius: 4px;
        padding: 1px 4px;
        font-size: 14px;
        font-weight: 400;
        top: -12px;
        left: -2px;
    }
    .card-color-six {
        background: linear-gradient(to right, #ff9b71, #e86254);
        color: #fff;
    }
    .card-backcolor {
        background: #ffdfd7;
        color: #ff704f;
    }
    .card .tag {
        position: absolute;
        top: 10px;
        left: 10px;
        background: #ffb300;
        color: #fff;
        font-size: 12px;
        padding: 2px 8px;
    }
    .card .tag.orange {
        background: #ff7e00;
    }
    .card .month {
        font-size: 12px;
        margin: 18px 0 0px 0;
        color: #333;
    }
    .card .price {
        font-size: 22px;
        color: #815A12;
    }
    .card .price .unit {
        font-weight: 600;
        font-size: 18px;
        display: inline-block;
    }
    .card .price .fee {
        font-weight: 900;
        display: inline-block;
        font-size: 32px;
    }
    .card .origin {
        font-size: 13px;
        color: #9c9c9c;
        text-decoration: line-through;
        margin-left: 4px;
        display: block;
    }
    .desc {
        font-size: 13px;
        color: rgba(129, 90, 18, 0.6);
        margin-top: 16px;
        background-color: #E9EDF1;
        border-bottom-left-radius: 6px;
        border-bottom-right-radius: 6px;
        color: #333;
    }
}

.sidebar {
    width: 260px;
    background: linear-gradient(to bottom, #45443D 0%, #1A150F 100%);
    color: #fff;
    padding: 40px 0 0 0;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.avatar-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    cursor: pointer;
}

.avatar {
    width: 72px;
    height: 72px;
    border-radius: 50%;
    margin-bottom: 12px;
    border: 3px solid #fff;
}

.user-id {
    font-size: 22px;
    margin-bottom: 4px;
    color: #F9D9A8;
}

.welcome {
    font-size: 15px;
    color: #bdbdbd;
    margin-bottom: 32px;
}

.vip-features {
    width: 100%;
    padding-left: 40px;
    color: #F9D9A8;
}

.features-title {
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 16px;
}

.vip-features ul {
    list-style: none;
    padding: 0;
    margin: 0;
}

.vip-features li {
    font-size: 16px;
    margin-bottom: 12px;
    letter-spacing: 1px;
}

.main-content {
    flex: 1;
    padding: 48px 32px 0 32px;
    background: linear-gradient(to bottom, #FFF5EC 0%, #fff 100%);
}

.vip-title {
    font-size: 24px;
    font-weight: bold;
    margin-bottom: 18px;
}

.vip-tabs {
    display: flex;
    gap: 18px;
    margin-bottom: 28px;
}

.tab {
    width: 182px;
    height: 48px;
    line-height: 48px;
    border: 1px solid #EBEBEB;
    border-radius: 6px;
    background: #fff;
    font-size: 14px;
    cursor: pointer;
    color: #000;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 600;
    img {
        width: 16px;
        height: 16px;
        margin-right: 10px;
    }
}

.tab.active {
    border: 1px solid #EACEA7;
    color: #7a5b2b;
    font-weight: bold;
}

.pay-title {
    font-size: 20px;
    font-weight: bold;
    margin-top: 35px;
    margin-bottom: 16px;
}

.pay-methods {
    display: flex;
    gap: 18px;
    margin-bottom: 28px;
}

.pay-btn {
    display: flex;
    align-items: center;
    padding: 10px 32px;
    border: 1px solid #e0e0e0;
    border-radius: 6px;
    background: #fff;
    font-size: 14px;
    cursor: pointer;
    color: #666;
    font-weight: 400;
    img {
        width: 16px;
        margin-right: 10px;
    }
}

.pay-btn.active {
    border-color: #f0e3d2;
    color: #815A12;
}

.pay-now {
    width: 88px;
    height: 40px;
    background: linear-gradient(to right, #524E3B 0%, #432F11 100%);
    color: #fff;
    font-size: 14px;
    border: none;
    border-radius: 6px;
    margin-bottom: 18px;
    cursor: pointer;
    font-weight: 400;
}

.pay-now-block {
    width: 88px;
    height: 40px;
    background: #D0D0D0;
    color: #fff;
    font-size: 14px;
    border: none;
    border-radius: 6px;
    margin-bottom: 18px;
    font-weight: 400;
}

.view-pay-now {
    width: 120px;
    height: 40px;
    background: linear-gradient(to right, #524E3B 0%, #432F11 100%);
    color: #fff;
    font-size: 14px;
    border: none;
    border-radius: 6px;
    margin-bottom: 18px;
    cursor: pointer;
    font-weight: 400;
}

.agreement {
    font-size: 12px;
    color: #333;
    margin-top: 8px;
    display: flex;
}

.agreement .link {
    color: #EE71A7;
    text-decoration: none;
    margin: 0 2px;
    font-weight: 400;
}

.qr-section {
    width: 260px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-left: 1px solid #EBEBEB;
    background: linear-gradient(to bottom, #FFF5EC 0%, #fff 100%);
    padding-bottom: 180px;
}

.qr-price {
    margin-top: 80px;
    margin-bottom: 18px;
    .unit {
        font-size: 16px;
        display: inline-block;
        vertical-align: middle;
        color: #a88a5a;
        font-weight: 600;
    }
    .fee {
        display: inline-block;
        vertical-align: middle;
        font-size: 32px;
        color: #a88a5a;
        font-weight: 900;
    }
}

.qr-img {
    width: 150px;
    height: 150px;
    margin-bottom: 20px;
    border-radius: 4px;
    border: 1px solid #EBEBEB;
    padding: 6px;
}

.qr-tip {
    font-size: 12px;
    color: #333;
    margin-bottom: 18px;
}

.mockBack {
    position: fixed;
    width: 100%;
    height: 100%;
    z-index: 20;
    background-color: #000;
    opacity: .7;
}

.login-form-card {
    z-index: 22;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 400px;
    background: #fff;
    border-radius: 18px;
    box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.15);
    .login-form {
        margin-top: 0;
        padding: 20px;
    }
    .el-form-item {
        margin-bottom: 22px;
        align-items: center;
    }
    .area-select {
        margin-right: 8px;
    }
    .phone-input {
        flex: 1;
    }
    .code-input {
        flex: 1;
        margin-right: 8px;
    }
    .send-code-btn {
        color: #EE71A7;
        font-weight: 400;
        padding: 0 8px;
        width: 90px;
    }
    .send-code-count {
        font-weight: 400;
        margin: -10px -20px;
        width: 90px;
        display: inline-block;
        text-align: center;
    }
    .login-btn {
        width: 100%;
        background: #EE71A7;
        border: none;
        font-size: 18px;
        font-weight: 600;
        border-radius: 8px;
        height: 44px;
        margin-top: 8px;
    }
    .login-btn:hover {
        background: #ffb6d5;
    }
    .agreement-item {
        margin-bottom: 0;
        font-size: 13px;
        color: #999;
        display: block;
        display: flex;
        .changer_sl {
            display: flex;
            .link {
                color: #EE71A7;
                text-decoration: none;
                margin: 0 2px;
                font-weight: 400;
            }
        }
    }
    .login-title {
        text-align: center;
        font-size: 20px;
        font-weight: 600;
        color: #222;
        padding: 40px 0px 20px 0px;
    }
}
</style>
